import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { createAddress } from "../../reduxStore/entities/address";
import RightArrowExtendedIconSVG from "../../../SharedComponents/assets/icons/svg/RightArrowExtendedIconSVG";
import { useNavigate } from "react-router-dom";

const CreateAddressForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        street: "",
        streetNumber: "",
        city: "",
        postalCode: "",
        lat: "",
        lon: ""
    });

    const handleChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        dispatch(createAddress({
            street: formData.street,
            streetNumber: formData.streetNumber,
            city: formData.city,
            postalCode: Number(formData.postalCode),
            lat: Number(formData.lat),
            lon: Number(formData.lon),
        }));
        navigate("/addresses");

    };

    return (
        <form onSubmit={handleSubmit} style={styles.formWrapper} autoComplete="off">
            <h3 style={styles.header}>Dodaj novu adresu</h3>

            <div style={styles.row}>
                <input
                    style={{ ...styles.input, flex: 2, marginRight: 10 }}
                    name="street"
                    placeholder="Ulica"
                    value={formData.street}
                    onChange={handleChange}
                    required
                />
                <input
                    style={{ ...styles.input, flex: 1 }}
                    name="streetNumber"
                    placeholder="Broj"
                    value={formData.streetNumber}
                    onChange={handleChange}
                    required
                />
            </div>

            <div style={styles.row}>
                <input
                    style={{ ...styles.input, flex: 2, marginRight: 10 }}
                    name="city"
                    placeholder="Grad"
                    value={formData.city}
                    onChange={handleChange}
                    required
                />
                <input
                    style={{ ...styles.input, flex: 1 }}
                    name="postalCode"
                    placeholder="Poštanski broj"
                    value={formData.postalCode}
                    onChange={handleChange}
                    required
                />
            </div>

            <div style={styles.row}>
                <input
                    style={{ ...styles.input, flex: 1, marginRight: 10 }}
                    name="lat"
                    placeholder="Latitude"
                    value={formData.lat}
                    onChange={handleChange}
                    required
                    type="number"
                    step="any"
                />
                <input
                    style={{ ...styles.input, flex: 1 }}
                    name="lon"
                    placeholder="Longitude"
                    value={formData.lon}
                    onChange={handleChange}
                    required
                    type="number"
                    step="any"
                />
            </div>

            <div style={styles.buttonWrapper}>
                <button style={styles.confirmButton} type="submit">
                    <span style={styles.buttonTextPadding}>Sačuvaj adresu</span>
                    <span style={styles.iconScale}>
                        <RightArrowExtendedIconSVG />
                    </span>
                </button>
            </div>

        </form>
    );
};

const styles = {
    formWrapper: {
        maxWidth: "50%",
        padding: 32,
        borderRadius: 8,
    },
    header: {
        fontSize: 24,
        fontWeight: "bold",
        color: "rgba(0, 0, 0, 0.87)",
        marginBottom: 24,
    },
    input: {
        padding: "12px 16px",
        fontSize: 16,
        borderRadius: 4,
        border: "1px solid #ccc",
        width: "100%",
        boxSizing: "border-box",
    },
    row: {
        display: "flex",
        marginTop: 20,
        marginBottom: 20,
    },
    buttonWrapper: {
        display: "flex",
        justifyContent: "center",
        marginTop: 16,
    },
    confirmButton: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "rgba(0, 0, 0, 0.9)",
        color: "#fff",
        fontSize: 20,
        fontWeight: "bold",
        border: "none",
        borderRadius: 6,
        cursor: "pointer",
        height: 60,
        padding: "0 24px",
        transition: "background-color 0.3s ease",
    },
    buttonTextPadding: {
        padding: "0 16px",
    },
    iconScale: {
        transform: "scale(1.4)",
    },
};

export default CreateAddressForm;
